import { FrameName } from "../config";
import GrasslandTerrainTileEntity from "./GrasslandTerrainTileEntity";

class Grassland3TerrainTileEntity extends GrasslandTerrainTileEntity {
	public static readonly frameName = FrameName.GRASSLAND3;
}

export default Grassland3TerrainTileEntity;
